import { FC } from 'react';
import cn from 'classnames';
import styles from './LandscapeIndicatorSupportingDocumentsTemplate.module.css';
import { Container } from 'react-bootstrap';
import {
  LandscapeIndicatorDocumentsOrganism,
  UploadIndicatorDocumentOrganism,
} from '../../organisms';
import { LandscapeDocumentResponseDto } from '../../../store/landscapeAPI/landscape/dto/response/landscape-document-response.dto';
import { FileMeta } from '../../../store/mediaAPI/document/dto/request/document-save-request';
import LandscapeIndicatorBaseTemplate from '../../../templates/LandscapeIndicatorBaseTemplate';

export interface LandscapeIndicatorSupportingDocumentsTemplateProps {
  data: LandscapeDocumentResponseDto[];
  handleEditAction: (id: string) => void;
  handleDownload: (id: string) => void;
  handleDelete: (id: string) => void;
  handleFileMetaOnChange: (fileMeta: FileMeta) => void;
  handleFileOnChange: (file: string) => void;
  handleFileNameOnChange: (name: string) => void;
  handleFileDescriptionOnChange: (description: string) => void;
  handleFileDateOnChange: (date: string) => void;
  callbackFn: () => void;
}

const LandscapeIndicatorSupportingDocumentsTemplate: FC<
  LandscapeIndicatorSupportingDocumentsTemplateProps
> = ({
  data,
  handleEditAction,
  handleDownload,
  handleDelete,
  handleFileMetaOnChange,
  handleFileOnChange,
  handleFileNameOnChange,
  handleFileDescriptionOnChange,
  handleFileDateOnChange,
  callbackFn,
}) => {
  return (
    <Container>
      <LandscapeIndicatorBaseTemplate>
        <div className={cn(styles.documentsWrapper)}>
          <LandscapeIndicatorDocumentsOrganism
            data={data}
            handleEditAction={handleEditAction}
            handleDelete={handleDelete}
            handleDownload={handleDownload}
          />
        </div>
        <UploadIndicatorDocumentOrganism
          setFile={(file) => handleFileOnChange(file)}
          setFileMeta={(fileMeta) => handleFileMetaOnChange(fileMeta)}
          setName={(name) => handleFileNameOnChange(name)}
          setDescription={(description) =>
            handleFileDescriptionOnChange(description)
          }
          setDate={(date) => handleFileDateOnChange(date)}
          callbackFn={callbackFn}
        />
      </LandscapeIndicatorBaseTemplate>
    </Container>
  );
};

export default LandscapeIndicatorSupportingDocumentsTemplate;
